import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Autoplay, Pagination, Keyboard } from "swiper/modules";
import ScrollToTop from './ScroollToTop';
import { ArrowRight } from 'react-feather';

const Home = () => {
  const heroImages = [
    'https://images.pexels.com/photos/1571468/pexels-photo-1571468.jpeg?auto=compress&cs=tinysrgb&w=1920',
    'https://images.pexels.com/photos/1866149/pexels-photo-1866149.jpeg?auto=compress&cs=tinysrgb&w=1920',
    'https://images.pexels.com/photos/276528/pexels-photo-276528.jpeg?auto=compress&cs=tinysrgb&w=1920',
    'https://images.pexels.com/photos/1571460/pexels-photo-1571460.jpeg?auto=compress&cs=tinysrgb&w=1920'
  ];

  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    heroImages.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, [heroImages]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % heroImages.length);
    }, 5000);
    return () => clearInterval(intervalId);
  }, [heroImages.length]);

  const products = [
    {
      id: 1,
      name: 'Luxe Leather Sofa',
      price: 107900,
      style: 'Modern',
      material: 'Leather',
      color: 'White',
      image: '/assets/mat_lea_2.jpg'
    },
    {
      id: 2,
      name: 'Contemporary Metal Chair',
      price: 41500,
      style: 'Contemporary',
      material: 'Metal',
      color: 'Blue',
      image: '/assets/mat_me_2.jpg'
    },
    {
      id: 3,
      name: 'Artisan Oak Coffee Table',
      price: 53500,
      style: 'Minimalist',
      material: 'Wood',
      color: 'Brown',
      image: '/assets/mat_lea_1.jpg'
    },
    {
      id: 4,
      name: 'Industrial Metal Bed Frame',
      price: 124900,
      style: 'Modern',
      material: 'Metal',
      color: 'Black',
      image: '/assets/mat_me_3.jpg'
    },
    {
      id: 5,
      name: 'Classic Leather Armchair',
      price: 75000,
      style: 'Contemporary',
      material: 'Glass',
      color: 'White',
      image: '/assets/mat_lea_3.jpg'
    },
    {
      id: 6,
      name: 'Modern Steel Side Table',
      price: 75000,
      style: 'Contemporary',
      material: 'Glass',
      color: 'White',
      image: '/assets/mat_me_1.jpg'
    }
  ];

  const [filters, setFilters] = useState({
    style: [],
    priceRange: [],
    material: [],
    color: []
  });

  const colorMap = {
    White: '#ffffff',
    Black: '#000000',
    Brown: '#A52A2A',
    'Dark Brown': '#654321',
    Blue: '#0000ff',
    Green: '#008000'
  };

  const handleFilterChange = (category, value) => {
    setFilters((prevFilters) => {
      const currentValues = prevFilters[category];
      if (currentValues.includes(value)) {
        return {
          ...prevFilters,
          [category]: currentValues.filter((v) => v !== value)
        };
      } else {
        return {
          ...prevFilters,
          [category]: [...currentValues, value]
        };
      }
    });
  };

  const sectionthirdSlides = [
    {
      tag: "Flexible",
      title: "Bundle of layout type different layout",
      img: "/assets/slide1.png",
    },
    {
      tag: "Unique",
      title: "We are delivering beautiful products",
      img: "/assets/slide2.png",
    },
    {
      tag: "Responsive",
      title: "True responsiveness modern responsive",
      img: "/assets/slide3.png",
    },
    {
      tag: "Modern",
      title: "Beautiful and modern latest page builder",
      img: "/assets/slide4.png",
    },
    {
      tag: "Modern",
      title: "Beautiful and modern latest page builder",
      img: "/assets/slide1.png",
    },
    {
      tag: "Modern",
      title: "Beautiful and modern latest page builder",
      img: "/assets/slide2.png",
    },
  ];

  const MySwiperComponent = () => {
    return (
      <Swiper
        modules={[Autoplay, Pagination, Keyboard]}
        spaceBetween={30}
        loop={true}
        autoplay={{ delay: 2500, disableOnInteraction: false }}
        keyboard={{ enabled: true, onlyInViewport: true }}
        breakpoints={{
          1200: { slidesPerView: 4 },
          992: { slidesPerView: 3 },
          768: { slidesPerView: 2 },
          0: { slidesPerView: 1 },
        }}
        className="mySwiper"
      >
        {sectionthirdSlides.map((slide, index) => (
          <SwiperSlide key={index}>
            <div className="relative overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 ease-in-out mb-5">
              <div className="relative w-full h-64 md:h-72 lg:h-80">
                <img
                  src={slide.img}
                  alt={slide.tag}
                  className="w-full h-full object-cover"
                  onError={(e) => { e.target.onerror = null; e.target.src = "https://placehold.co/800x600/cccccc/000?text=Image+Error" }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-transparent to-transparent opacity-70"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-6 text-white">
                <span className="inline-block bg-gray-500 text-black text-xs font-semibold px-3 py-1 rounded-full mb-2 md:mb-3 uppercase tracking-wider">
                  {slide.tag}
                </span>
                <h3 className="font-inter text-base md:text-lg lg:text-xl font-serif mb-3 md:mb-4 leading-tight">
                  {slide.title}
                </h3>
                <button
                  type="button"
                  className="inline-block bg-white text-gray-800 text-xs md:text-sm font-serif no-underline hover:underline px-4 md:px-5 py-1.5 md:py-2 rounded-full shadow-md hover:bg-gray-100 transition duration-300"
                >
                  Learn more
                </button>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    );
  };

  const filterProducts = () => {
    return products.filter((product) => {
      if (filters.style.length > 0 && !filters.style.includes(product.style)) {
        return false;
      }
      if (filters.material.length > 0 && !filters.material.includes(product.material)) {
        return false;
      }
      if (filters.color.length > 0 && !filters.color.includes(product.color)) {
        return false;
      }
      if (filters.priceRange.length > 0) {
        let priceMatch = false;
        filters.priceRange.forEach((range) => {
          if (range === 'Under ₹40,000' && product.price < 40000) {
            priceMatch = true;
          } else if (
            range === '₹40,000 - ₹80,000' &&
            product.price >= 40000 &&
            product.price <= 80000
          ) {
            priceMatch = true;
          } else if (
            range === '₹80,000 - ₹150,000' &&
            product.price > 80000 &&
            product.price <= 150000
          ) {
            priceMatch = true;
          } else if (range === 'Over ₹150,000' && product.price > 150000) {
            priceMatch = true;
          }
        });
        if (!priceMatch) return false;
      }
      return true;
    });
  };

  const filteredProducts = filterProducts();

  return (
    <div className="bg-white min-h-screen animate-slideUp font-serif">
      <ScrollToTop />
      <section
        style={{
          backgroundImage: `linear-gradient(to right, rgba(255,255,255,0.7) 30%, transparent 80%), url(${heroImages[currentSlide]})`
        }}
        className="h-[50vh] md:h-[70vh] lg:h-screen bg-cover bg-center transition-all duration-1000 ease-in-out flex items-center px-4 sm:px-8 lg:px-16"
      >
        <div className="w-full sm:w-3/4 md:w-2/3 lg:w-1/2 max-w-2xl text-left font-serif">
          <p className="text-xl sm:text-3xl md:text-4xl lg:text-5xl text-black mb-4 leading-tight">
            Timeless Design for Modern Living
          </p>
          <p className="text-gray-900 mb-6 sm:mb-8 text-sm sm:text-base md:text-lg">
            Discover our collection of premium furniture crafted for contemporary spaces.
          </p>
          <button className="bg-black text-white py-2 px-6 sm:py-3 sm:px-8 text-sm sm:text-base rounded-lg shadow-md hover:bg-gray-800 transition-colors duration-300">
            Shop Now
          </button>
        </div>
      </section>

      <section className="py-12 sm:py-16 px-4">
        <h3 className="text-center text-2xl sm:text-3xl font-semibold mb-8">
          Browse by Category
        </h3>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 max-w-6xl mx-auto">
          <Link to="/living-room" className="text-center block group no-underline">
            <div className="relative overflow-hidden bg-gray-100 rounded-lg mb-2">
              <div className="aspect-[4/3] w-full">
                <img
                  src="/assets/Gallery1.png"
                  alt="Living Room"
                  className="absolute inset-0 w-full h-full object-cover object-top transform group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                  onError={(e) => { e.target.onerror = null; e.target.src = "https://placehold.co/600x450/E5E7EB/6B7280?text=Living+Room"; }}
                  style={{ objectPosition: 'center 20%' }}
                />
              </div>
            </div>
            <span className="text-gray-600 group-hover:text-black font-medium text-sm sm:text-base block">Living Room</span>
          </Link>
          <Link to="/bedroom" className="text-center block group no-underline">
            <div className="relative overflow-hidden bg-gray-100 rounded-lg mb-2">
              <div className="aspect-[4/3] w-full">
                <img
                  src="/assets/Gallery2.png"
                  alt="Bedroom"
                  className="absolute inset-0 w-full h-full object-cover object-top transform group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                  onError={(e) => { e.target.onerror = null; e.target.src = "https://placehold.co/600x450/E5E7EB/6B7280?text=Bedroom"; }}
                  style={{ objectPosition: 'center 20%' }}
                />
              </div>
            </div>
            <span className="text-gray-600 group-hover:text-black font-medium text-sm sm:text-base block">Bedroom</span>
          </Link>
          <Link to="/restaurant" className="text-center block group no-underline">
            <div className="relative overflow-hidden bg-gray-100 rounded-lg mb-2">
              <div className="aspect-[4/3] w-full">
                <img
                  src="/assets/caf_fd_3.jpg"
                  alt="Restaurant"
                  className="absolute inset-0 w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                  onError={(e) => { e.target.onerror = null; e.target.src = "https://placehold.co/600x450/E5E7EB/6B7280?text=Restaurant"; }}
                />
              </div>
            </div>
            <span className="text-gray-600 group-hover:text-black font-medium text-sm sm:text-base block">Restaurant</span>
          </Link>
          <Link to="/bar" className="text-center block group no-underline">
            <div className="relative overflow-hidden bg-gray-100 rounded-lg mb-2">
              <div className="aspect-[4/3] w-full">
                <img
                  src="/assets/caf_bst_1.jpg"
                  alt="Bar"
                  className="absolute inset-0 w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                  onError={(e) => { e.target.onerror = null; e.target.src = "https://placehold.co/600x450/E5E7EB/6B7280?text=Bar"; }}
                />
              </div>
            </div>
            <span className="text-gray-600 group-hover:text-black font-medium text-sm sm:text-base block">Bar</span>
          </Link>
          <Link to="/cafe" className="text-center block group no-underline">
            <div className="relative overflow-hidden bg-gray-100 rounded-lg mb-2">
              <div className="aspect-[4/3] w-full">
                <img
                  src="/assets/caf_caf_1.jpg"
                  alt="Cafe"
                  className="absolute inset-0 w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                  onError={(e) => { e.target.onerror = null; e.target.src = "https://placehold.co/600x450/E5E7EB/6B7280?text=Cafe"; }}
                />
              </div>
            </div>
            <span className="text-gray-600 group-hover:text-black font-medium text-sm sm:text-base block">Cafe</span>
          </Link>
        </div>
      </section>

      <section className="py-12 sm:py-16 bg-gray-50 px-4 mt-5 bg-cover bg-no-repeat bg-fixed bg-center ease-in-out" style={{
        backgroundImage: `linear-gradient(to left, rgba(255,255,255,0.85), rgba(255,255,255,0.6) 90%), url('/assets/Gallery2.png')`
      }}>
        <h2 className="text-center text-2xl sm:text-3xl md:text-4xl font-bold mb-4 sm:mb-6">
          Featured Products
        </h2>
        <p className="text-center text-gray-600 mb-6 sm:mb-8 text-sm sm:text-base md:text-lg px-4">
          Handpicked selections for your modern space
        </p>
        <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          <div className="bg-white shadow-lg rounded-lg overflow-hidden transform hover:scale-105 transition-transform duration-300">
            <div className="relative overflow-hidden bg-gray-100">
              <div className="aspect-[4/5] w-full">
                <img
                  src="/assets/caf_bst_4.jpg"
                  alt="Premium Bar Stool"
                  className="absolute inset-0 w-full h-full object-cover"
                  loading="lazy"
                  onError={(e) => { e.target.onerror = null; e.target.src = "https://placehold.co/600x750/E5E7EB/6B7280?text=Premium+Bar+Tool"; }}
                />
              </div>
            </div>
            <div className="p-4">
              <h3 className="text-base sm:text-lg md:text-xl font-semibold mb-2 line-clamp-2">Premium Bar Stool</h3>
            </div>
          </div>

          <div className="bg-white shadow-lg rounded-lg overflow-hidden transform hover:scale-105 transition-transform duration-300">
            <div className="relative overflow-hidden bg-gray-100">
              <div className="aspect-[4/5] w-full">
                <img
                  src="/assets/caf_caf_2.jpg"
                  alt="Elegant Cafe Chair"
                  className="absolute inset-0 w-full h-full object-cover"
                  loading="lazy"
                  onError={(e) => { e.target.onerror = null; e.target.src = "https://placehold.co/600x750/E5E7EB/6B7280?text=Elegant+Cafe+Chair"; }}
                />
              </div>
            </div>
            <div className="p-4">
              <h3 className="text-base sm:text-lg md:text-xl font-semibold mb-2 line-clamp-2">Elegant Cafe Chair</h3>
            </div>
          </div>

          <div className="bg-white shadow-lg rounded-lg overflow-hidden transform hover:scale-105 transition-transform duration-300">
            <div className="relative overflow-hidden bg-gray-100">
              <div className="aspect-[4/5] w-full">
                <img
                  src="https://images.pexels.com/photos/1395967/pexels-photo-1395967.jpeg?auto=compress&cs=tinysrgb&w=800&q=80"
                  alt="Fine Dining Table Set"
                  className="absolute inset-0 w-full h-full object-cover"
                  loading="lazy"
                  onError={(e) => { e.target.onerror = null; e.target.src = "https://placehold.co/600x750/E5E7EB/6B7280?text=Fine+Dining+Table"; }}
                />
              </div>
            </div>
            <div className="p-4">
              <h3 className="text-base sm:text-lg md:text-xl font-semibold mb-2 line-clamp-2">
                Fine Dining Table Set
              </h3>
            </div>
          </div>

          <div className="bg-white shadow-lg rounded-lg overflow-hidden transform hover:scale-105 transition-transform duration-300">
            <div className="relative overflow-hidden bg-gray-100">
              <div className="aspect-[4/5] w-full">
                <img
                  src="/assets/Gallery6.png"
                  alt="Luxury Bedroom Suite"
                  className="absolute inset-0 w-full h-full object-cover object-top"
                  loading="lazy"
                  onError={(e) => { e.target.onerror = null; e.target.src = "https://placehold.co/600x750/E5E7EB/6B7280?text=Luxury+Bedroom"; }}
                  style={{ objectPosition: 'center 20%' }}
                />
              </div>
            </div>
            <div className="p-4">
              <h3 className="text-base sm:text-lg md:text-xl font-semibold mb-2 line-clamp-2">Luxury Bedroom Suite</h3>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 px-4 md:px-8 lg:px-16">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mt-2 mb-12">
            <span className="inline-block font-inter text-base md:text-lg text-blue-600 font-medium mb-3 uppercase tracking-wide">
              Why choose us
            </span>
            <h2 className="font-inter text-3xl md:text-4xl font-bold text-gray-800 mb-[10px] leading-tight">
              Beautifully Handcrafted and Elegant Furniture's For Your Amazing Space
            </h2>
          </div>
          <div className="relative">
            {MySwiperComponent()}
          </div>
        </div>
      </section>

      <section className="w-full py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="relative w-full" style={{ paddingBottom: "56.25%" }}>
            <iframe
              className="absolute top-0 left-0 w-full h-full rounded-lg shadow-2xl"
              src="https://www.youtube.com/embed/eA0yoVhTdF8?si=5YzsMZxn5NAszU2W&autoplay=1&mute=1&loop=1&playlist=eA0yoVhTdF8"
              title="Furniture Promo Video"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </section>

      <section className="pt-8 pb-12 sm:pb-16 bg-gray-200 px-4">
        <h2 className="text-center text-2xl sm:text-3xl md:text-4xl font-bold mb-6 sm:mb-8">
          Collection Highlights
        </h2>
        <div className="max-w-6xl mx-auto space-y-8 sm:space-y-10">
          <div className="flex flex-col md:flex-row items-center gap-6 md:gap-8">
            <div className="w-full md:w-1/2 relative overflow-hidden bg-gray-100 rounded-lg shadow-md">
              <div className="aspect-[4/3] w-full">
                <img
                  src="https://images.pexels.com/photos/4352247/pexels-photo-4352247.jpeg?auto=compress&cs=tinysrgb&w=800&q=80"
                  alt="Nordic Simplicity"
                  className="absolute inset-0 w-full h-full object-cover"
                  loading="lazy"
                  onError={(e) => { e.target.onerror = null; e.target.src = "https://placehold.co/800x600/E5E7EB/6B7280?text=Nordic+Simplicity"; }}
                />
              </div>
            </div>
            <div className="w-full md:w-1/2 flex flex-col items-center px-4 md:px-0">
              <h3 className="text-xl sm:text-2xl md:text-3xl font-semibold mb-3 sm:mb-4 text-center">
                Nordic Simplicity
              </h3>
              <p className="text-gray-600 mb-4 sm:mb-6 text-sm sm:text-base md:text-lg text-center">
                Clean lines and natural materials inspired by Scandinavian design
                principles.
              </p>
              <Link to="/livingroom" className="group inline-flex items-center bg-black text-white py-2 px-6 sm:py-3 sm:px-8 text-sm sm:text-base rounded-lg shadow-md hover:bg-gray-800 transition-colors duration-300 no-underline">
                View Collection
                <ArrowRight className="ml-2 h-4 w-4 sm:h-5 sm:w-5 transform transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
            </div>
          </div>

          <div className="flex flex-col md:flex-row-reverse items-center gap-6 md:gap-8">
            <div className="w-full md:w-1/2 relative overflow-hidden bg-gray-100 rounded-lg shadow-md">
              <div className="aspect-[4/3] w-full">
                <img
                  src="https://images.pexels.com/photos/6315800/pexels-photo-6315800.jpeg?auto=compress&cs=tinysrgb&w=800&q=80"
                  alt="Urban Modern"
                  className="absolute inset-0 w-full h-full object-cover"
                  loading="lazy"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src =
                      "https://placehold.co/800x600/E5E7EB/6B7280?text=Urban+Modern";
                  }}
                />
              </div>
            </div>
            <div className="w-full md:w-1/2 flex flex-col items-center px-4 md:px-0">
              <h3 className="text-xl sm:text-2xl md:text-3xl font-semibold mb-3 sm:mb-4 text-center">
                Urban Modern
              </h3>
              <p className="text-gray-600 mb-4 sm:mb-6 text-sm sm:text-base md:text-lg text-center">
                Contemporary pieces with industrial touches for the modern city dweller.
              </p>
              <Link to="/bedroom" className="group inline-flex items-center bg-black text-white py-2 px-6 sm:py-3 sm:px-8 text-sm sm:text-base rounded-lg shadow-md hover:bg-gray-800 transition-colors duration-300 no-underline">
                View Collection
                <ArrowRight className="ml-2 h-4 w-4 sm:h-5 sm:w-5 transform transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="py-12 sm:py-16 lg:py-20 px-4 sm:px-6 lg:px-8 mt-8 sm:mt-12 lg:mt-16 mb-8 sm:mb-12 lg:mb-16">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-center text-2xl sm:text-3xl md:text-4xl font-bold mb-6 sm:mb-8">Shop Living Room</h2>
          <div className="flex flex-col lg:flex-row gap-6 lg:gap-8">
            <aside className="lg:w-1/4 bg-white shadow-lg p-4 sm:p-6 rounded-lg">
              <h3 className="text-lg sm:text-xl font-semibold mb-4">Filters</h3>

              <div className="mb-6">
                <h4 className="font-medium mb-2 text-base sm:text-lg">Style</h4>
                <div className="flex flex-col space-y-2">
                  {['Modern', 'Contemporary', 'Minimalist'].map((style) => (
                    <label key={style} className="inline-flex items-center text-sm sm:text-base cursor-pointer">
                      <input
                        type="checkbox"
                        value={style}
                        checked={filters.style.includes(style)}
                        onChange={() => handleFilterChange('style', style)}
                        className="form-checkbox h-4 w-4 sm:h-5 sm:w-5 text-blue-600 rounded-md"
                      />
                      <span className="ml-2 text-gray-700">{style}</span>
                    </label>
                  ))}
                </div>
              </div>

              <div className="mb-6">
                <h4 className="font-medium mb-2 text-base sm:text-lg">Material</h4>
                <div className="flex flex-col space-y-2">
                  {['Wood', 'Metal', 'Fabric', 'Leather', 'Glass'].map((material) => (
                    <label key={material} className="inline-flex items-center text-sm sm:text-base cursor-pointer">
                      <input
                        type="checkbox"
                        value={material}
                        checked={filters.material.includes(material)}
                        onChange={() => handleFilterChange('material', material)}
                        className="form-checkbox h-4 w-4 sm:h-5 sm:w-5 text-blue-600 rounded-md"
                      />
                      <span className="ml-2 text-gray-700">{material}</span>
                    </label>
                  ))}
                </div>
              </div>

              <div className="mb-6">
                <h4 className="font-medium mb-2 text-base sm:text-lg">Color</h4>
                <div className="flex flex-wrap gap-2 sm:gap-3">
                  {['White', 'Black', 'Brown', 'Dark Brown', 'Blue', 'Green'].map((color) => (
                    <div
                      key={color}
                      onClick={() => handleFilterChange('color', color)}
                      className={`w-8 h-8 sm:w-10 sm:h-10 cursor-pointer border-2 ${filters.color.includes(color) ? 'border-blue-500 ring-2 ring-blue-300' : 'border-gray-300'
                        } transition-all duration-200`}
                      style={{ backgroundColor: colorMap[color] }}
                      title={color}
                    />
                  ))}
                </div>
              </div>
            </aside>

            <div className="lg:w-3/4">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
                {filteredProducts.length > 0 ? (
                  filteredProducts.map((product) => (
                    <div key={product.id} className="bg-white shadow-lg rounded-lg overflow-hidden transform hover:scale-105 transition-transform duration-300">
                      <div className="relative overflow-hidden bg-gray-100">
                        <div className="aspect-[4/5] w-full">
                          <img
                            src={product.image}
                            alt={product.name}
                            className="absolute inset-0 w-full h-full object-cover object-center transform transition-transform duration-500 hover:scale-105"
                            loading="lazy"
                            onError={(e) => { 
                              e.target.onerror = null; 
                              e.target.src = `https://placehold.co/600x750/E5E7EB/6B7280?text=${encodeURIComponent(product.name)}`; 
                            }}
                          />
                        </div>
                      </div>
                      <div className="p-3 sm:p-4">
                        <h3 className="text-sm sm:text-base md:text-lg lg:text-xl font-semibold mb-2 line-clamp-2">{product.name}</h3>
                        <p className="text-xs sm:text-sm text-gray-600">
                          {product.style} • {product.material}
                        </p>
                      </div>
                    </div>
                  ))
                ) : (
                  <p className="text-center col-span-full text-gray-600 text-base sm:text-lg py-10">No products match the selected filters.</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
